export default class HouseAdLocation {}
HouseAdLocation.NavbarTop = 'navbar-top';
HouseAdLocation.NavbarBottom = 'navbar-bottom';
